var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"bytedance-button",class:[
    `bytedance-button-${_vm.size}`,
    { 'bytedance-button-loading': _vm.loading },
  ]},_vm.$listeners),[_c('span',[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._t("default",function(){return [_vm._v("bytedance-button")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }